import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function FieldsBlock({ block, value = {}, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="rounded-xl border border-border bg-card/60 p-4 sm:p-5 print-avoid-break">
      {block.title && <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-foreground">{block.title}</h4>}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {block.fields.map((f) => (
          <div key={f.k} className={f.full || f.type === "textarea" ? "sm:col-span-2" : ""}>
            <Label className="mb-1.5 block text-xs font-medium text-muted-foreground">{f.label}</Label>
            {f.type === "textarea" ? (
              <Textarea
                data-testid={`field-${block.key}-${f.k}`}
                value={value[f.k] || ""}
                onChange={(e) => set(f.k, e.target.value)}
                className="min-h-[80px] bg-secondary/40"
              />
            ) : f.type === "select" ? (
              <Select value={value[f.k] || ""} onValueChange={(v) => set(f.k, v)}>
                <SelectTrigger data-testid={`field-${block.key}-${f.k}`} className="bg-secondary/40">
                  <SelectValue placeholder="Select" />
                </SelectTrigger>
                <SelectContent>
                  {f.options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
                </SelectContent>
              </Select>
            ) : (
              <Input
                data-testid={`field-${block.key}-${f.k}`}
                type={f.type === "number" ? "number" : f.type === "date" ? "date" : f.type === "time" ? "time" : "text"}
                value={value[f.k] || ""}
                placeholder={f.placeholder || ""}
                onChange={(e) => set(f.k, e.target.value)}
                className={`bg-secondary/40 ${f.type === "number" ? "font-mono" : ""}`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
